"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentsTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _constants = require("../utils/constants");
var _DataGridProTable = require("./DataGridProTable");
var _RenderDateCell = require("./Table/RenderDateCell");
var _RenderDownloadCell = require("./Table/RenderDownloadCell");
var _RenderHeaderNameTranslatin = require("./Table/RenderHeaderNameTranslatin");
var _selectors = require("../redux/selectors");
var _actions = require("../redux/actions");
var _RenderTranslatedCell = require("./Table/RenderTranslatedCell");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const DocumentsTable = () => {
  const dispatch = (0, _reactRedux.useDispatch)();
  const documents = (0, _reactRedux.useSelector)(_selectors.selectDocumentsBySiteId, (prev, next) => _paulCorePackage.functions.areEqual(prev, next));
  const siteId = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveSiteId);
  const token = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getToken);
  (0, _react.useEffect)(() => {
    if (siteId && token) dispatch((0, _actions.getDocuments)({
      siteId
    }));
  }, [dispatch, siteId, token]);
  const documentsTableColumns = [{
    field: 'name',
    renderHeader: () => /*#__PURE__*/_react.default.createElement(_RenderHeaderNameTranslatin.RenderHeaderNameTranslation, {
      headerNameKey: "name"
    }),
    renderCell: item => {
      var _item$row;
      return /*#__PURE__*/_react.default.createElement(_RenderTranslatedCell.RenderTranslatedCell, {
        text: (_item$row = item.row) === null || _item$row === void 0 ? void 0 : _item$row.name,
        defaultContent: "-"
      });
    },
    width: 300
  }, {
    field: 'createdAt',
    renderHeader: () => /*#__PURE__*/_react.default.createElement(_RenderHeaderNameTranslatin.RenderHeaderNameTranslation, {
      headerNameKey: "created"
    }),
    renderCell: item => {
      var _item$row2;
      return /*#__PURE__*/_react.default.createElement(_RenderDateCell.RenderDateCell, {
        date: (_item$row2 = item.row) === null || _item$row2 === void 0 ? void 0 : _item$row2.createdAt
      });
    },
    width: 200
  }, {
    field: 'modifiedAt',
    renderHeader: () => /*#__PURE__*/_react.default.createElement(_RenderHeaderNameTranslatin.RenderHeaderNameTranslation, {
      headerNameKey: "lastUpdate"
    }),
    renderCell: item => {
      var _item$row3;
      return /*#__PURE__*/_react.default.createElement(_RenderDateCell.RenderDateCell, {
        date: (_item$row3 = item.row) === null || _item$row3 === void 0 ? void 0 : _item$row3.modifiedAt
      });
    },
    width: 200
  }, {
    field: 'type',
    renderHeader: () => /*#__PURE__*/_react.default.createElement(_RenderHeaderNameTranslatin.RenderHeaderNameTranslation, {
      headerNameKey: "category"
    }),
    renderCell: item => {
      var _item$row4;
      return /*#__PURE__*/_react.default.createElement(_RenderTranslatedCell.RenderTranslatedCell, {
        text: (_item$row4 = item.row) === null || _item$row4 === void 0 ? void 0 : _item$row4.type,
        defaultContent: "-"
      });
    },
    width: 200
  }, {
    field: 'url',
    headerName: '',
    renderCell: item => /*#__PURE__*/_react.default.createElement(_RenderDownloadCell.RenderDownloadCell, {
      fileData: item.row,
      filenameFunc: tV => {
        var _tV, _item$row5, _item$row6;
        return "paul-".concat((_tV = tV((_item$row5 = item.row) === null || _item$row5 === void 0 ? void 0 : _item$row5.type)) === null || _tV === void 0 ? void 0 : _tV.toLowerCase(), "-").concat((_item$row6 = item.row) === null || _item$row6 === void 0 ? void 0 : _item$row6.name);
      }
    })
  }];
  return /*#__PURE__*/_react.default.createElement(_paulCorePackage.StorageStateDataGridProTable, {
    localStorageId: _constants.tableKeysLocalStorage.documentTable,
    columns: documentsTableColumns,
    rows: documents,
    Component: _DataGridProTable.DataGridProTable,
    isClearFilters: false,
    margin: "0",
    alignItems: "center",
    getEstimatedRowHeight: () => 42,
    getRowHeight: () => 59
  });
};
exports.DocumentsTable = DocumentsTable;